/**
 * Галерея екранів кейсу: слайдер на Swiper.
 *
 * Автопрокрутки немає навмисно — скриншоти розглядають у своєму темпі.
 * Прив'язка в межах секції блока (.phpdev-gallery), бо id задає редактор,
 * а блок може стояти на сторінці не один.
 */

(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.phpdev-gallery').forEach(function (root) {
    var el = root.querySelector('.gallery.swiper');
    if (!el || typeof Swiper === 'undefined') return;

    var slides = el.querySelectorAll('.swiper-slide').length;
    if (slides < 2) return;           /* один екран — гортати нічого */

    var count = root.querySelector('.slide-count');
    var total = ('0' + slides).slice(-2);

    function setCount(sw) {
      if (count) count.textContent = ('0' + (sw.realIndex + 1)).slice(-2) + ' / ' + total;
    }

    new Swiper(el, {
      speed: reduce ? 0 : 500,
      spaceBetween: 16,
      /* Ширину задає саме зображення: висота слайда фіксована стилями, тож
         скільки знімків влізе в екран — стільки й буде видно. */
      slidesPerView: 'auto',
      rewind: true,                   /* з останнього — назад на перший */
      grabCursor: true,
      navigation: {
        prevEl: root.querySelector('[data-prev]'),
        nextEl: root.querySelector('[data-next]')
      },
      pagination: {
        el: root.querySelector('.dots'), clickable: true,
        bulletClass: 'dot-btn', bulletActiveClass: 'is-on',
        renderBullet: function (index, className) {
          return '<button type="button" class="' + className +
                 '" aria-label="' + (index + 1) + '"></button>';
        }
      },
      on: { init: setCount, slideChange: setCount }
    });
  });

  // Лайтбокс. Bind, а не прив'язка до кожного слайда: Swiper клонує слайди у
  // деяких режимах, і навішені вручну обробники на клонах не спрацьовували б.
  if (typeof Fancybox !== 'undefined') {
    Fancybox.bind('[data-fancybox="case-gallery"]', {});
  }
})();
